import React, { useState, useCallback } from 'react';

import { Tabs, AppBar, Tab as TabUI } from '@material-ui/core';
import PropTypes from 'prop-types';

import { TabPanel } from './components';

export default function Tab({ items, center }) {
  const [tab, setTab] = useState(0);

  // change tab (header)
  const handleChangeTab = (e, value) => {
    setTab(value);
  };

  // props tab
  const a11yProps = (index) => ({
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  });

  // header tab
  const renderHeaderTab = useCallback(
    () =>
      items.map((item, index) => (
        <TabUI
          key={item.label}
          label={item.label}
          {...a11yProps(Number(index))}
        />
      )),
    [items]
  );

  // content tab
  const renderContentTab = useCallback(
    () =>
      items.map((item, index) => (
        <TabPanel
          key={`tab-${item.label}`}
          value={tab}
          index={index}
        >
          {item.content}
        </TabPanel>
      )),
    [items, tab]
  );

  return (
    <>
      <AppBar position="static" color="default">
        <Tabs
          centered={center}
          value={tab}
          onChange={handleChangeTab}
          indicatorColor="primary"
          textColor="primary"
        >
          {renderHeaderTab()}
        </Tabs>
      </AppBar>

      {renderContentTab()}
    </>
  );
}

Tab.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
        .isRequired,
    })
  ).isRequired,
  center: PropTypes.bool,
};

Tab.defaultProps = {
  center: false,
};
